/**
 * Created by mqamhieh on 12/26/16.
 */
window.AMSMessageCandidateForm = function (scope, Upload, candidates, formData) {
    var form = this;
    var formName = "ams-message-candidate-form";
    var _protected = BaseForm.call(form, formName, scope);
    var _emitter = JarEventEmitter.call(form);

    var selectedTemplate;

    form.candidates = candidates;
    form.templates = [];
    form.attachments = [];
    form.hadNoTemplates;

    form.load = function (laneId) {
        var defer = $q.defer();

        form.laneId = laneId;

        CustomLanesAPI.getTemplates(laneId, formData.brandId, formData.jobId, { include_parent: true })
            .then(function (templates) {
                form.templates = templates;
                if (!form.templates.enterprise_templates.length && ! form.templates.job_templates.length) {
                    form.hadNoTemplates = true;
                    form.toggleView();
                }
                scope.$digest();
            });

        return defer.promise;
    }

    form.setSelected = function (candidates) {
        form.data.selected_candidates = candidates;
    };

    form.send = function () {
        form.validator.validate(function(isValid) {
            if (isValid) {
                var applicationsIds = _.pluck(form.data.selected_candidates, 'application_id');
                var URL = CustomLanesAPI.getCreateTemplateURL(form.laneId, formData.brandId, formData.jobId);

                var requestData = {
                    application_ids: applicationsIds
                };

                if (form.data.template_id) {
                    requestData['template_id'] = form.data.template_id;
                }
                else {
                    requestData['message'] = form.data.message;
                    requestData['attachments'] = form.attachments;
                }

                form.sending = true;

                Upload.upload({
                    'url': URL + '/messages',
                    'method': 'POST',
                    'withCredentials': true,
                    'headers': {},
                    'data': requestData,
                    'Content-Type': 'multipart/form-data',
                    'arrayKey': '[]'
                }).progress(function (evt) {
                    form.uploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (data, status, headers, config) {
                    // file is uploaded successfully
                    if (data.status_code == 200) {
                        _emitter.trigger("done", form.data, form.attachments, form.hadNoTemplates);
                    }
                    else {
                        console.error("Error while sending message:", data);
                    }

                    delete form.sending;
                }).error(function (reason) {
                    console.error("Error while sending message:", reason);
                    delete form.sending;
                });
            }
        });
    };

    form.toggleView = function () {
        if (form.customMessage) {
            form.data.template_id = selectedTemplate;
        }
        else {
            selectedTemplate = form.data.template_id;
            form.data.template_id = '';
        }

        form.validator.validation = {};
        form.customMessage = !form.customMessage;
    };

    form.addAttachments = function (files) {
        if (files && files.length) {
            form.attachments = form.attachments.concat(files);
        }
    };

    form.removeAttachment = function (index) {
        form.attachments.splice(index, 1);
    };
};